import { render, staticRenderFns } from "./pianoCompanyManageRouter.vue?vue&type=template&id=3a180255&"
import script from "./pianoCompanyManageRouter.vue?vue&type=script&lang=js&"
export * from "./pianoCompanyManageRouter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports